import React, { useContext /*, useEffect, useState */ } from 'react';
import { MDBDataTable } from 'mdbreact';
import PropTypes from 'prop-types';
import { isEmpty /* orderBy */ } from 'lodash';

import './sortable_table.scss';
import { commonModules } from '../index';

const SortableTable = (props) => {
  const { className, data: rawData,  noBottomColumns, responsive, searching, entries, children,
          onSort: onSortData, pagingNotRequired, maxHeight, onPageChange: onActivePageChange} = props,
        { storeContext, useTranslateText } = commonModules,
        { state } = useContext(storeContext),
        { translateText } = useTranslateText(),
        { LangCode } = state;

  const onSort = (value) => {
    const { column, direction } = value,
          isAscending = direction === 'asc',
          className = !isAscending ? 'sortable-table__th-content-asc' : 'sortable-table__th-content-dsc';

    rawData.columns.map(item => {
      // item.label = translateText(item.label);

      if (column === item.field) {
        item.label = <p className={className}>{item.key}</p>;
      }
      else {
        item.label = item.key;
      }
    });

  };

  if (isEmpty(rawData)) return <span />;
  const { rows } = rawData || {},
        entriesCount = entries || 10,
        canShowPaging = rows && rows.length > entriesCount;

  return (
    <div className={`sortable-table ${className}`}>
      {rawData?.heading && <p className="sortable-table__heading">{rawData?.heading}</p>}
      <MDBDataTable
        id="MDBDataTable1"
        paging= {pagingNotRequired === true ? false : canShowPaging}
        paginationLabel={LangCode === 'EN' ? ['Previous', 'Next'] : ['Previo', 'Próximo']}
        data={rawData}
        noBottomColumns={noBottomColumns || true}
        entries={entriesCount}
        responsive={responsive || false}
        searching={searching || false}
        disableRetreatAfterSorting={true}
        noRecordsFoundLabel={translateText('No matching records found.')}
        onSort={onSortData ? onSortData : (value) => onSort(value)}
        onPageChange={onActivePageChange ? onActivePageChange : null}
        scrollY = {maxHeight ? true : false}
        maxHeight= {maxHeight ? maxHeight : false}
      />
        {children}
    </div>
  );
};


SortableTable.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default SortableTable;

/**************************
 const data = {
   className: 'className',
   columns: [
      { label: 'Heading 1', field: 'row_field1', sort: '', width: 150 },
      { label: 'Heading 2', field: 'row_field2', sort: 'asc', width: 150 },
   ],
   rows: [
     { row_field1: 'row_field1 data1', row_field2: 'row_field2 data1'},
     { row_field1: 'row_field1 data2', row_field2: 'row_field2 data2'},
     { row_field1: 'row_field1 data3', row_field2: 'row_field2 data3'},
   ],
   children: <div><p> Children </p></div>
  }

  <SortableTable data={data} />
 */